import Loadable from 'app/components/Loadable'
import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'

const History = Loadable(lazy(() => import('../pages/templateHistory/index')))

const templateHistoryRoutes: RouteObject[] = [
  {
    path: '/template-history',
    element: <History />,
  },
]

export default templateHistoryRoutes
